import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AddPaymentForm from './AddPaymentForm';
import Clients from "./Clients";
import PropertyRegisterDashboard from "./PropertyRegisterDashboard";
import Properties from "./Properties";

const PropertyRegisterRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PropertyRegisterDashboard />} />
      <Route path="/add-payment" element={<AddPaymentForm />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/view" element={<Properties />} />

    </Routes>
  );
}

export default PropertyRegisterRoutes;
